(() => {
  function initialize(scope = document) {
    scope.querySelectorAll('[data-footer-picker]').forEach(picker => {
      if (picker.dataset.ready) return;
      picker.dataset.ready = 'true';
      const summary = picker.querySelector('summary');
      const panel = picker.querySelector('.cv-footer__locale-panel');
      const choices = [...picker.querySelectorAll('[data-footer-locale-name]')];
      function position() {
        panel.style.setProperty('--footer-menu-shift', '0px');
        const bounds = panel.getBoundingClientRect();
        const rightLimit = document.documentElement.clientWidth - 16;
        const shift = bounds.left < 16 ? 16 - bounds.left : bounds.right > rightLimit ? rightLimit - bounds.right : 0;
        panel.style.setProperty('--footer-menu-shift', `${shift}px`);
        panel.style.setProperty('--footer-menu-height', `${Math.max(80, Math.min(272, summary.getBoundingClientRect().top - 20))}px`);
      }
      picker.addEventListener('toggle', () => {
        if (!picker.open) return;
        document.querySelectorAll('[data-footer-picker][open]').forEach(other => { if (other !== picker) other.open = false; });
        position();
        const current = choices.find(button => button.getAttribute('aria-pressed') === 'true');
        if (current && !choices.includes(document.activeElement)) panel.scrollTop = Math.max(0, current.offsetTop - panel.clientHeight / 2 + current.offsetHeight / 2);
      });
      picker.addEventListener('click', event => {
        const button = event.target.closest('[data-footer-locale-name]');
        if (!button) return;
        const form = picker.closest('form');
        const input = form.elements.namedItem(button.dataset.footerLocaleName);
        if (!input || form.hasAttribute('data-submitting')) return;
        picker.open = false;
        if (input.value === button.dataset.footerLocaleValue) { summary.focus(); return; }
        input.value = button.dataset.footerLocaleValue;
        form.setAttribute('data-submitting', '');
        form.requestSubmit();
      });
      picker.addEventListener('keydown', event => {
        if (event.key === 'Escape') { picker.open = false; summary.focus(); return; }
        if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        picker.open = true;
        const index = choices.indexOf(document.activeElement);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? choices.length - 1 : event.key === 'ArrowDown' ? (index + 1) % choices.length : (index < 0 ? choices.length - 1 : (index - 1 + choices.length) % choices.length);
        choices[next]?.focus();
      });
      window.addEventListener('resize', () => { if (picker.open) position(); });
    });
  }
  document.addEventListener('pointerdown', event => {
    document.querySelectorAll('[data-footer-picker][open]').forEach(picker => { if (!picker.contains(event.target)) picker.open = false; });
  });
  document.addEventListener('focusin', event => {
    document.querySelectorAll('[data-footer-picker][open]').forEach(picker => { if (!picker.contains(event.target)) picker.open = false; });
  });
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
